// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#MapFilter div.map-filter-entry {
    margin: 0.25em;
    border: 1px solid var(--border-color);
}

#MapFilter div.map-filter-entry-titlebar {
    padding: 0.25em;
    background-color: var(--titlebar-bg-color);
    color: var(--titlebar-text-color);
    font-weight: bold;
    display: flex;
    align-items: center;
    height: 2em;
}

#MapFilter div.map-filter-entry-titlebar > .map-filter-entry-title {
    flex: 1 1 auto;
    overflow-x: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

#MapFilter div.map-filter-entry-titlebar > div.ToggleSwitch {
    flex: 0 0 6em;
    height: 1.5em;
}

#MapFilter div.map-filter-entry-body {
    padding: 0.25em;
}

#MapFilter div.map-filter-entry-body > div:not(:last-child) {
    margin-bottom: 0.25em;
}

#MapFilter div.map-filter-invalid-warning {
    background-color: orange;
    display: flex;
    align-items: center;
    padding: 0.25em 0.5em;
    margin: 0.25em;
}

#MapFilter div.map-filter-invalid-warning > div {
    margin-left: 0.25em;
}

#MapFilter table.map-filter-entry-fields {
    border-collapse: collapse;
    width: 100%;
}

#MapFilter table.map-filter-entry-fields td:first-child {
    white-space: nowrap;
}

#MapFilter table.map-filter-entry-fields td:last-child {
    width: 99%;
}

#MapFilter table.map-filter-entry-fields td:last-child > * {
    width: 100%;
}

#MapFilter div.map-filter-add-custom {
    margin: 0 0.25em 0.25em 0.25em;
}

#MapFilter div.map-filter-custom-entry-titlebar {
    display: flex;
}

#MapFilter div.map-filter-custom-entry-titlebar > div.TextInput {
    flex: 1 1 auto;
}

#MapFilter div.map-filter-custom-entry-titlebar > div.ToggleSwitch {
    margin: 0 0.5em;
}

#MapFilter div.map-filter-add-custom > button {
    width: 100%;
}

#MapFilter input.map-filter-custom-entry-expr {
    min-width: 0;
    width: 100%;
}

#MapFilter div.map-filter-editor-container {
    padding: 0.25em;
}

#MapFilter div.map-filter-editor {
    height: 5em;
}

#MapFilter div.map-filter-editor-invalid {
    background-color: rgba(255, 127, 127);
}

button.filter-map-button-error {
    background-color: orange;

}`, "",{"version":3,"sources":["webpack://./plugins/style/MapFilter.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,qCAAqC;AACzC;;AAEA;IACI,eAAe;IACf,0CAA0C;IAC1C,iCAAiC;IACjC,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,wBAAwB;IACxB,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,wBAAwB;;AAE5B","sourcesContent":["#MapFilter div.map-filter-entry {\n    margin: 0.25em;\n    border: 1px solid var(--border-color);\n}\n\n#MapFilter div.map-filter-entry-titlebar {\n    padding: 0.25em;\n    background-color: var(--titlebar-bg-color);\n    color: var(--titlebar-text-color);\n    font-weight: bold;\n    display: flex;\n    align-items: center;\n    height: 2em;\n}\n\n#MapFilter div.map-filter-entry-titlebar > .map-filter-entry-title {\n    flex: 1 1 auto;\n    overflow-x: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n#MapFilter div.map-filter-entry-titlebar > div.ToggleSwitch {\n    flex: 0 0 6em;\n    height: 1.5em;\n}\n\n#MapFilter div.map-filter-entry-body {\n    padding: 0.25em;\n}\n\n#MapFilter div.map-filter-entry-body > div:not(:last-child) {\n    margin-bottom: 0.25em;\n}\n\n#MapFilter div.map-filter-invalid-warning {\n    background-color: orange;\n    display: flex;\n    align-items: center;\n    padding: 0.25em 0.5em;\n    margin: 0.25em;\n}\n\n#MapFilter div.map-filter-invalid-warning > div {\n    margin-left: 0.25em;\n}\n\n#MapFilter table.map-filter-entry-fields {\n    border-collapse: collapse;\n    width: 100%;\n}\n\n#MapFilter table.map-filter-entry-fields td:first-child {\n    white-space: nowrap;\n}\n\n#MapFilter table.map-filter-entry-fields td:last-child {\n    width: 99%;\n}\n\n#MapFilter table.map-filter-entry-fields td:last-child > * {\n    width: 100%;\n}\n\n#MapFilter div.map-filter-add-custom {\n    margin: 0 0.25em 0.25em 0.25em;\n}\n\n#MapFilter div.map-filter-custom-entry-titlebar {\n    display: flex;\n}\n\n#MapFilter div.map-filter-custom-entry-titlebar > div.TextInput {\n    flex: 1 1 auto;\n}\n\n#MapFilter div.map-filter-custom-entry-titlebar > div.ToggleSwitch {\n    margin: 0 0.5em;\n}\n\n#MapFilter div.map-filter-add-custom > button {\n    width: 100%;\n}\n\n#MapFilter input.map-filter-custom-entry-expr {\n    min-width: 0;\n    width: 100%;\n}\n\n#MapFilter div.map-filter-editor-container {\n    padding: 0.25em;\n}\n\n#MapFilter div.map-filter-editor {\n    height: 5em;\n}\n\n#MapFilter div.map-filter-editor-invalid {\n    background-color: rgba(255, 127, 127);\n}\n\nbutton.filter-map-button-error {\n    background-color: orange;\n\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
